var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 0.875C9.89844 7.80237 6.15475 14 0.875 14C6.15475 14 9.89844 20.198 9.89844 27.125C9.89844 20.198 13.6421 14 18.9219 14C13.6421 14 9.89844 7.80237 9.89844 0.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5627 14C20.5627 17.4642 18.6915 20.5625 16.0508 20.5625C18.6915 20.5625 20.5627 23.6617 20.5627 27.125C20.5627 23.6617 22.434 20.5625 25.0747 20.5625C22.434 20.5625 20.5627 17.4642 20.5627 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6135 0.875C22.6135 4.33868 20.7423 7.4375 18.1016 7.4375C20.7418 7.4375 22.6135 10.5367 22.6135 14C22.6135 10.5367 24.4847 7.4375 27.1255 7.4375C24.4847 7.4375 22.6135 4.33868 22.6135 0.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerate);
export default __webpack_public_path__ + "static/media/ai-generate.f3910fbd9505d43d2095812e5c313b5b.svg";
export { ForwardRef as ReactComponent };